(function($) {

    $(window).on('load', function() {

        $.fn.is_on_screen = function(){
            var win = $(window);
            var viewport = {
                top : win.scrollTop(),
                left : win.scrollLeft()
            };
            viewport.bottom = viewport.top + win.height();

            var bounds = this.offset();
            bounds.bottom = bounds.top + this.outerHeight();

            return (!(viewport.bottom < bounds.top || viewport.top > bounds.bottom));
        };

        coctailBarDeco();
        coctailBarSection();
        tequilaFirstScreenDeco();

        faqPage();
        faqItem();

        fromTop();
        fromLeft();
        fromRight();
        fromBottom();
        ft_pictures();

        $(window).scroll(function(e){
            coctailBarDeco();
            coctailBarSection();
            tequilaFirstScreenDeco();

            faqPage();
            faqItem();

            fromTop();
            fromLeft();
            fromRight();
            fromBottom();
            ft_pictures();
        });


        if($('.homepage .banner').length > 0){
            // if($('.homepage .banner').is_on_screen()) {
            //     setTimeout(function(){
            //         if($('.homepage .banner').is_on_screen()) {
            //             $('html, body').animate({
            //                 scrollTop: $('.homepage .banner').next().offset().top - 300
            //             }, 1500);
            //         } else {
            //
            //         }
            //     }, 7000);
            // }
        }

        function secondSection(){
            if($('.secondScreen').length > 0) {
                if ($('.secondScreen .secondText').is_on_screen()) {
                    $('.secondScreen .secondText').each(function (i) {
                        var el = $(this);
                        setTimeout(function () {
                            el.removeClass('fromTop');
                        }, 300 * i);
                    });
                }
            }
        }


        function secondScreenDeco(){
            if($('.secondScreen .secondScreen__deco--part').length > 0) {
                if ($('.secondScreen .secondScreen__deco--part').is_on_screen()) {
                    $('.secondScreen .secondScreen__deco--part').each(function (i) {
                        var el = $(this);
                        setTimeout(function () {
                            el.removeClass('opacity');
                        }, 100 * i);
                    });
                } else {
                    $('.secondScreen .secondScreen__deco--part').each(function (i) {
                        var el = $(this);
                        setTimeout(function () {
                            el.addClass('opacity');
                        }, 100 * i);
                    });
                }
            }
        }

        function cheersSectionDeco() {
            if($('.cheers .cheers__deco--part').length > 0) {
                if ($('.cheers .cheers__deco--part').is_on_screen()) {
                    $('.cheers .cheers__deco--part').each(function (i){
                        var el = $(this);
                        setTimeout(function(){
                            el.removeClass('opacity');
                        }, 300*i);
                    });
                } else {
                    $('.cheers .cheers__deco--part').each(function (i){
                        var el = $(this);
                        setTimeout(function(){
                            el.addClass('opacity');
                        }, 300*i);
                    });
                }
            }
        }



        function coctailBarDeco() {
            if($('.coctailBar .coctailBar__deco--part').length > 0) {
                if ($('.coctailBar .coctailBar__deco--part').is_on_screen()) {
                    $('.coctailBar .coctailBar__deco--part').each(function (i){
                        var el = $(this);
                        setTimeout(function(){
                            el.removeClass('opacity');
                        }, 200*i);
                    });
                } else {
                    $('.coctailBar .coctailBar__deco--part').each(function (i){
                        var el = $(this);
                        setTimeout(function(){
                            el.addClass('opacity');
                        }, 200*i);
                    });
                }
            }
        }

        function coctailBarSection() {
            if($('.coctailBar').length > 0) {
                if ($('.coctailBar').is_on_screen()) {
                    $('.coctailBarTitle').removeClass('fromTop');
                    setTimeout(function () {
                        $('.coctailBarDescription').removeClass('fromTop');
                    }, 100);
                    setTimeout(function () {
                        $('.coctailBarTequilas').removeClass('fromTop');
                    }, 300);
                }
            }
        }

        function cheersSection(){
            if($('.cheersAbout').length > 0) {
                if ($('.cheersAbout').is_on_screen()) {
                    $('.cheersAbout').find('picture').removeClass('fromLeft');
                    $('.cheersAbout').find('.cheersInfo').removeClass('fromRight');
                }
            }
        }

        function historySection(){
            if($('.cheersAbout').length > 0) {
                if ($('.historyAbout').is_on_screen()) {
                    $('.history').find('picture').removeClass('fromLeft');
                    $('.history').find('.historyInfo').removeClass('fromRight');
                }
            }
        }

        function historyDeco(){
            if($('.history .history__deco--part').length > 0) {
                if ($('.history .history__deco--part').is_on_screen()) {
                    $('.history .history__deco--part').each(function (i) {
                        var el = $(this);
                        setTimeout(function () {
                            el.removeClass('opacity');
                        }, 100 * i);
                    });
                } else {
                    $('.history .history__deco--part').each(function (i) {
                        var el = $(this);
                        setTimeout(function () {
                            el.addClass('opacity');
                        }, 100 * i);
                    });
                }
            }
        }

        function productsSection(){
            if($('.products').length > 0) {
                if ($('.products').is_on_screen()) {
                    $('.products').find('picture.deco').removeClass('scaleDown');
                }
            }
        }

        function tequilaFirstScreenFlower(){
            if($('.tequilaFirstScreen').length > 0) {
                if ($('.tequilaFirstScreen').find('picture.deco').is_on_screen()) {
                    $('.tequilaFirstScreen').find('picture.deco').removeClass('scaleDown');
                }
            }
        }

        function tequilaFirstScreenDeco() {
            if($('.tequilaFirstScreen .tequilaFirstScreen__deco--part').length > 0) {
                if ($('.tequilaFirstScreen .tequilaFirstScreen__deco--part').is_on_screen()) {
                    $('.tequilaFirstScreen .tequilaFirstScreen__deco--part').each(function (i){
                        var el = $(this);
                        setTimeout(function(){
                            el.removeClass('opacity');
                        }, 200*i);
                    });
                } else {
                    $('.tequilaFirstScreen .tequilaFirstScreen__deco--part').each(function (i){
                        var el = $(this);
                        setTimeout(function(){
                            el.addClass('opacity');
                        }, 200*i);
                    });
                }
            }
        }

        function tequilaStoryDeco() {
            if($('.tequilaStory .tequilaStory__deco--part').length > 0) {
                if ($('.tequilaStory .tequilaStory__deco--part').is_on_screen()) {
                    $('.tequilaStory .tequilaStory__deco--part').each(function (i){
                        var el = $(this);
                        setTimeout(function(){
                            el.removeClass('opacity');
                        }, 200*i);
                    });
                } else {
                    $('.tequilaStory .tequilaStory__deco--part').each(function (i){
                        var el = $(this);
                        setTimeout(function(){
                            el.addClass('opacity');
                        }, 200*i);
                    });
                }
            }
        }

        function tequilaStorySection() {
            if($('.tequilaStory').length > 0) {
                if ($('.tequilaStory').is_on_screen()) {
                    $('.tequilaStory').find('picture').removeClass('fromLeft');
                    $('.tequilaStory').find('.tequilaStoryInfo').removeClass('fromRight');
                }
            }
        }

        function fromTop() {
            if($('.ft').length > 0) {
                $('.ft').each(function(i){
                    var thisFt = $(this);
                    setTimeout(function (){
                        if ($(thisFt).is_on_screen()) {
                            thisFt.removeClass('fromTop');
                        }
                    }, 200 * i);
                });
            }
        }
        function fromBottom() {
            if($('.f_b').length > 0) {
                $('.f_b').each(function(i){
                    var thisFb = $(this);
                    setTimeout(function (){
                        if ($(thisFb).is_on_screen()) {
                            thisFb.removeClass('fromBottom');
                        }
                    }, 200 * i);
                });
            }
        }

        function fromLeft() {
            if($('.fl').length > 0) {
                $('.fl').each(function(i){
                    var thisFl = $(this);
                    setTimeout(function (){
                        if ($(thisFl).is_on_screen()) {
                            thisFl.removeClass('fromLeft');
                        }
                    }, 200 * i);
                });
            }
        }

        function fromRight() {
            if($('.fr').length > 0) {
                $('.fr').each(function(i){
                    var thisFr = $(this);
                    setTimeout(function (){
                        if ($(thisFr).is_on_screen()) {
                            thisFr.removeClass('fromRight');
                            if(thisFr.hasClass('coctailItemReceiptNew__block')) {
                                thisFr.addClass('line');
                            }
                        }
                    }, 200 * i);
                });
            }
        }
        function ft_pictures() {
            if($('.ft_pictures').length > 0) {
                $('.ft_pictures').each(function(i){
                    var thisFt = $(this);
                    setTimeout(function (){
                        if ($(thisFt).is_on_screen()) {
                            thisFt.removeClass('fromTop');
                        }
                    }, 200 * i);
                });
            }
        }


        function faqPage() {
            if($('.faqContainer').length > 0) {
                if ($('.faqContainer').is_on_screen()) {
                    $('.faqTitle').removeClass('fromTop');
                    setTimeout(function () {
                        $('.faqDescription').removeClass('fromTop');
                    }, 150);
                }
            }
        }
        function faqItem(){
            if($('.faqItem').length > 0) {
                if ($('.faqItem').is_on_screen()) {
                    $('.faqItem').each(function (i){
                        var $t = $(this);
                        setTimeout(function(){
                            $t.removeClass('quiet');
                        }, 250 * i);
                    });
                }
            }
        }

        svgLinePath();

        $(window).on('resize', function () {
            svgLinePath();
        });

        function svgLinePath() {
            if($('.productionTechnologyBackgroundContainer--fifth path').length > 0) {
                var ticking = false;
                var last_known_scroll_position = 0;
                var updatePath = false;
                if($(window).width() > 1024) {
                    var element = document.querySelector('.productionTechnologyBackgroundContainer--fifth.desktop');
                    var path = element.querySelector('path');
                } else if(($(window).width() < 1025) && ($(window).width() > 767)){
                    var element = document.querySelector('.productionTechnologyBackgroundContainer--fifth.tablet');
                    var path = element.querySelector('path');
                } else if($(window).width() < 768){
                    var element = document.querySelector('.productionTechnologyBackgroundContainer--fifth.mobile');
                    var path = element.querySelector('path');
                }

                var totalLength = 0;

                initPath(path)

                function initPath(path){
                    totalLength = path.getTotalLength();
                    path.style.strokeDasharray = `${totalLength}`;
                    path.style.strokeDashoffset = totalLength;
                }


                function handleEntries(entries) {
                    entries.forEach(entry => {
                        if(entry.isIntersecting) {
                        }

                    })
                }

                var observer = new IntersectionObserver((entries, observer) => {
                    entries.forEach(entry => {
                        if(entry.isIntersecting){
                            updatePath = true;
                        } else {
                            updatePath = false;
                        }
                    });
                }, {rootMargin: "0px 0px 0px 0px"});


                observer.observe(element);

                function doSomething(scroll_pos) {
                    if(!updatePath) {
                        return;
                    }
                    window.requestAnimationFrame(()=>{
                        var center = window.innerHeight / 2;
                        var boundaries = path.getBoundingClientRect();
                        var top = boundaries.top;
                        const height = boundaries.height;
                        var percentage = (center - top ) / height;
                        var drawLength = percentage > 0 ? totalLength * percentage : 0;
                        path.style.strokeDashoffset = drawLength < totalLength ? totalLength - drawLength : 0;

                    })

                }

                window.addEventListener('scroll', function(e) {
                    last_known_scroll_position = window.scrollY;

                    if (!ticking) {
                        window.requestAnimationFrame(function() {
                            doSomething(last_known_scroll_position);
                            ticking = false;
                        });

                        ticking = true;
                    }
                });
            }
        }

        function shakeIt() {
            $('.productionTechnologyListItem').each(function(i) {
                var $t = $(this);
                setTimeout(function() {
                    $('.productionTechnologyListItem').not($t).removeClass('active');
                    $t.addClass('active');
                }, 5000 * i);
            });
        }
        shakeIt();
        setInterval(function() {
            shakeIt();
            $('.productionTechnologyListItem').removeClass('active');
        }, $('.productionTechnologyListItem').length*5000);

    });

})( jQuery );